export default {
  __html: `<g  fill="currentColor" fill-rule="evenodd" transform="translate(-10, -30)">>
    <g fill-rule="nonzero">
        <path fill="#c5c3d8" d="M50.297 71.386h-6.04c-1.683 0-2.97-1.386-2.97-2.97 0-1.683 1.386-2.97 2.97-2.97h6.04c1.683 0 2.97-1.387 2.97-2.97 0-1.684-1.386-2.971-2.97-2.971h-1.98c-4.95 0-9.01-4.06-9.01-9.01s4.06-9.01 9.01-9.01h6.04c1.683 0 2.97 1.386 2.97 2.97 0 1.585-1.386 2.97-2.97 2.97h-6.04c-1.683 0-2.97 1.387-2.97 2.971 0 1.683 1.386 2.97 2.97 2.97h1.98c4.95 0 9.01 4.06 9.01 9.01s-4.06 9.01-9.01 9.01z"/>
        <path fill="#c5c3d8" d="M49.307 47.327c-1.683 0-2.97-1.386-2.97-2.97v-6.04c0-1.683 1.386-2.97 2.97-2.97 1.584 0 2.97 1.386 2.97 2.97v6.04c0 1.683-1.287 2.97-2.97 2.97zM49.109 76.436c-1.683 0-2.97-1.386-2.97-2.97v-4.951c0-1.683 1.386-2.97 2.97-2.97 1.683 0 2.97 1.386 2.97 2.97v4.95c0 1.585-1.287 2.97-2.97 2.97z"/>  
    </g>
</g>`
}



// WEBPACK FOOTER //
// ./src/app/elements/Icon/dollar-sign.js